import templateUrl from "emun.cart/download-cart-images-prompt.htm";
import singleTemplateUrl from "emun.cart/download-cart-images-prompt.single.htm";
import controller from "emun.cart/download-cart-images-prompt.controller";
import open from "webmodals/open";

export default (options) =>
  open({
    size: options.size || "md",
    templateUrl:
      options.templateUrl ||
      (options.productId ? singleTemplateUrl : templateUrl),
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options,
    },
  }).result;
